import SashiDo from 'lib/SashiDo';
import AppsManager from 'lib/AppsManager';
import GoogleTagManager from 'lib/GoogleTagManager';
import DashboardView from 'dashboard/DashboardView.react';
import SashiDoLogo from 'components/SashiDoLogo/SashiDoLogo.react';
import Button from 'components/Button/Button.react';
import Icon from 'components/Icon/Icon.react';
import Popover from 'components/Popover/Popover.react';
import React from 'react';
import history from 'dashboard/history';
import PropTypes from 'prop-types';
import styles from './MigrateAppAnimation.scss';
import ParseApp from 'lib/ParseApp';
import Notification from 'components/Notification/Notification.react';

import LoadingParticles from 'components/LoadingParticles/LoadingParticles.react';

import Tooltip from 'rc-tooltip';


import { regionsList } from 'lib/Constants';

const SexyServer = ({ status, name }) => {
  const serverBarsRender = () => {
    const rackBars = [...(new Array(10))].map((_, i) => (
      <div className={styles.bar_item} key={i + new Date()} />
    ));

    return rackBars;
  };

  const classes = [styles.server];

  if (status === 'loading') { classes.push(styles.barActive); }
  if (status === 'finished') { classes.push(styles.barFinished); }

  return (
    <div>
      <div className={classes.join(' ')}>
        <div className={styles.left}>
          <div className={[styles.circle_small, styles.yellow].join(' ')} />
          <div className={[styles.circle_small, styles.green].join(' ')} />
        </div>
        <div className={styles.barsvert}>
          {serverBarsRender()}
        </div>
        <div className={styles.name}>{name}</div>
        <div className={styles.right}>
          <div className={[styles.circle_small, styles.blue].join(' ')} />
        </div>
      </div>
      <div className={styles.dock} />
    </div>
  );
};


export default class MigrateAppAnimation extends DashboardView {
  constructor(props) {
    super();
    this.state = {
      showFinishMigrationScreen: false,
      migrationLoading: true,
      showCoupon: false,
      note: null,

      currentApp: 2,
      status_app: null,
      status_settings: null,
      status_server: null,
      status_database: null,
      status_cloud_code: null,
    };

    this._timer = null;
    this._interval = null;


    this.appName = AppsManager.findAppBySlug(props.params.appId).name;
  }

  componentDidMount() {
    this.setState({ status_settings: 'loading' });

    document.body.addEventListener('keydown', this.handleKey);

    this.setState({
      statusIndicator1: true,
      statusIndicator2: true,
      statusIndicator3: true,
      statusIndicator4: true,
      statusIndicator5: true,
      statusIndicator6: true,
      statusIndicator7: true,

      status_app: 'loading',
      status_settings: 'loading',
      status_server: 'loading',
      status_database: 'loading',
    });


    const app = this.context.currentApp;

    this._timer = setTimeout(() => {
      app.migration_server().then(() => {
        this.setState({
          statusIndicator8: true,
          status_app: 'finished',
          status_settings: 'finished',
          status_server: 'finished',
          status_database: 'finished',
        }, () => {
          this._interval = setTimeout(() => {
            this.setState({ status_database: 'finished', showFinishMigrationScreen: true });
          }, 3000);
        });
      });
    }, 3000);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
    if (this._timer) { clearTimeout(this._timer); }
    if (this._interval) { clearInterval(this._interval); }
  }

  // getCoupons() {
  //   return SashiDo.getUserBillingCoupons();
  // }

  handleKey = (e) => {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick();
        break;
    }
  }

  onCloseClick = () => {
    Intercom('trackEvent', 'app_created', { appName: this.context.currentApp.name });

    window.location = '/products/apps';
  }

  onContinueClick = () => {
    Intercom('trackEvent', 'app_created', { appName: this.context.currentApp.name });

    window.location = `/products/apps/${this.context.currentApp.slug}/getting-started`;
  }

  onAddCreditCardClick = () => {
    history.replace('/billing/add_card');
  }

  handleInfoClose = () => {
    this.setState({ currentApp: 2 });
  }

  handleInfoOpen = () => {
    this.setState({ currentApp: 1 });
  }

  render() {
    const CancelIcon =
      this.state.migrationLoading && this.state.status_database == 'finished' // TODO alabala show show show
        ? (<a href="javascript:;" className={styles.iconClose} onClick={this.onCloseClick.bind(this)} >
          <Icon width={16} height={16} name="icon-close" />
        </a>)
        : null;

    const content = (
      <div
        className={[
          styles.wrap,
          this.state.currentApp ? styles[`app-${this.state.currentApp}`] : null,
          this.state.showFinishMigrationScreen ? styles.showFinishMigrationScreen : null,
        ].join(' ')}>

        <div className={styles.bytes}>
          <LoadingParticles customClass={!this.state.statusIndicator8 ? 'creating' : null} logo={false} />
        </div>

        <p className={styles.patient}>Please be patient, this may take awhile.</p>

        <div className={[styles.racks, this.state.currentApp2].join(' ')}>
          <div className={[styles.rack, this.state.currentApp == 2 ? styles.currentApp : ''].join(' ')}>
            <h2>{this.context.currentApp.name}
              <Tooltip placement="top" overlay="Behind the scenes" arrowContent={<div className="rc-tooltip-arrow-inner" />}>
                <a href="javascript:;" className={styles.infoOpen} onClick={this.handleInfoOpen}>
                  <Icon width={24} height={24} name="icon-read-tag" colored />
                </a>
              </Tooltip>
            </h2>
            <SexyServer name="Application" status={this.state.status_app} />
            <SexyServer name="Settings" status={this.state.status_settings} />
            <SexyServer name="Parse Server" status={this.state.status_server} />
            <SexyServer name="Database" status={this.state.status_database} />
          </div>
        </div>
        <div className={styles.info}>
          <h2>We build really scalable infrastructure for every app!</h2>
          <div className={[styles.box].join(' ')}>
            <a href="javascript:;" className={styles.infoClose} onClick={this.handleInfoClose} >
              <Icon width={12} height={12} name="icon-close" />
            </a>
            <h3>See how it looks like behind the scenes</h3>
            <div className={styles.paragraphs}>
              <p><span className={[styles.tag, this.state.statusIndicator1 ? styles.green : null].join(' ')}>Creating</span>Unique hostname for your app.</p>
              <p><span className={[styles.tag, this.state.statusIndicator2 ? styles.green : null].join(' ')}>Building</span>Docker images for your Parse Server deployment.</p>
              <p><span className={[styles.tag, this.state.statusIndicator3 ? styles.green : null].join(' ')}>Deploying</span>Scalable Docker infrastructure with load balancing and highly availability.</p>
              <p><span className={[styles.tag, this.state.statusIndicator4 ? styles.green : null].join(' ')}>Setting up</span>Infrastructure and services monitoring.</p>
              <p><span className={[styles.tag, this.state.statusIndicator5 ? styles.green : null].join(' ')}>Deploying</span>Highly available MongoDB replica set.</p>
              <p><span className={[styles.tag, this.state.statusIndicator6 ? styles.green : null].join(' ')}>Preparing</span>GitHub repo for your cloud code.</p>
              <p><span className={[styles.tag, this.state.statusIndicator7 ? styles.green : null].join(' ')}>Finalize</span>The configurations of your application cluster.</p>
              <p><span className={[styles.tag, this.state.statusIndicator8 ? styles.green : styles.blue].join(' ')}>Testing</span>All the components are up and running.</p>
            </div>
          </div>
        </div>
      </div>
    );

    if (this.state.showFinishMigrationScreen) {
      const {
        currentApp,
      } = this.context;

      SashiDo.activityTrack({
        type: 'create_app',
        data: {
          message: `Successfully created application ${currentApp.name}`,
        },
      });

      const getTransactionTotal = (region) => {
        const filter = regionsList.filter(p => p.key === region);
        const str = filter[0].value_after;
        const value = parseFloat(str.match(/[\d\.]+/));

        return value;
      };

      GoogleTagManager({
        data: {
          event: 'addToCart',
          pageCategory: 'new-app',
          transactionId: currentApp.serviceName,
          transactionTotal: getTransactionTotal(currentApp.region),
          transactionProducts: [
            {
              sku: `app-${currentApp.region}`,
              name: 'app',
              category: 'parse-applicaions',
              price: getTransactionTotal(currentApp.region),
              quantity: 1,
            },
          ],
        },
      });

      return (
        <Popover modal onExternalClick={() => this.setState({ open: true })}>
          <div className={styles.migrate}>
            <div className={styles.showEffect} />
            <div className={[styles.holder, styles.woohou].join(' ')}>
              <h1>Woohouu! You've successfully created your app</h1>
              <p>Proceed with connecting to SashiDo and start the journey.</p>
              {
                // this.props.currentCustomer.has_payment_method ? coupon : noCreditCard
              }
              <div className={styles.form}>
                <div className={styles.buttonHolder}>
                  <Button color="blue" value="Continue" size="big" block onClick={this.onContinueClick} />
                </div>
              </div>
            </div>
            <Notification note={this.state.note} fullscreen />
            <SashiDoLogo />
            {CancelIcon}
          </div>
        </Popover>
      );
    }

    return (
      <Popover modal onExternalClick={() => this.setState({ open: true })}>
        <div className={[styles.migrate, styles.migrateFade].join(' ')}>
          { this.state.migrationLoading ? content : null }
          <SashiDoLogo zIndex={300} showUp />
          {CancelIcon}
        </div>
      </Popover>
    );
  }
}


MigrateAppAnimation.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
